module.exports = __webpack_public_path__ + "static/media/icon-campaign.62c57ded.svg";